import ModalTermsAndConditions from './ModalTermsAndConditions';
export default ModalTermsAndConditions;
